module.exports = __webpack_public_path__ + "static/media/carton-house-resort.b91119b1.jpg";